/*
 * mysUtilities.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

export const toBase64 = (input) => {
    return window.btoa(input)
}
export const fromBase64 = (input) => {
    return window.atob(input)
}

export const isNullOrEmpty = (input) => {
    return input === undefined || input === null || input.length === 0
}

export const setStorage = (key, value) => {
    localStorage.setItem(key, value)
}

export const getStorage = (key) => {
    if (localStorage.getItem(key)) {
        return localStorage.getItem(key)
    }
    return ''
}
